var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("scroll", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var keyframe = ref.keyframe
              return [_vm._v(" Current Keyframe: " + _vm._s(keyframe) + " ")]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }